import fixtures from './fixtureTypes/fixtures'
import objects from './fixtureTypes/objects'
import lasers from './fixtureTypes/lasers'
import other from './fixtureTypes/other'

import fixtureFamilies from './fixtureFamilies'
import fixtureTypes from './fixtureTypes'

export {
  fixtureFamilies,
  fixtureTypes,
}

export const families = [
  {
    label: 'profile.properties.fixtures',
    value: fixtureFamilies.FIXTURE,
    icon: 'Images/Icons/profilebuilder/fixtures/Lyre.png',
    // What properties to show or not depending on type
    properties: {
      // LAMP
      lamp_power: true,
      lamp_ref: true,
      lamp_type: true,
      lamp_life: true,
      lamp_temp: true,
      color: false,
      // BEAM ANGLE
      beam_opening: true,
      beam_opening2: false,
      beam_type: true,
      // PAN/TILT
      pan_angle: true,
      tilt_angle: true,
      pan_center: true,
      tilt_center: true,
      inv_pan: true,
      inv_tilt: true,
      time_pan: true,
      time_tilt: true,
    },
    types: fixtures,
  },
  {
    label: 'profile.properties.objects',
    value: fixtureFamilies.OBJECT,
    icon: 'Images/Icons/profilebuilder/fixtures/Panel.png',
    // What properties to show or not depending on type
    properties: {
      // LAMP
      lamp_power: true,
      lamp_ref: true,
      lamp_type: true,
      lamp_life: true,
      lamp_temp: true,
      color: false,
      // BEAM ANGLE
      beam_opening: true,
      beam_opening2: true,
      beam_type: false,
      // PAN/TILT
      pan_angle: false,
      tilt_angle: false,
      pan_center: false,
      tilt_center: false,
      inv_pan: false,
      inv_tilt: false,
      time_pan: false,
      time_tilt: false,
    },
    types: objects,
  },
  {
    label: 'profile.properties.lasers',
    value: fixtureFamilies.LASER,
    icon: 'Images/Icons/profilebuilder/fixtures/Laser.png',
    // What properties to show or not depending on type
    properties: {
      // LAMP
      lamp_power: true,
      lamp_ref: false,
      lamp_type: false,
      lamp_life: false,
      lamp_temp: false,
      color: true,
      // BEAM ANGLE
      beam_opening: false,
      beam_opening2: false,
      beam_type: false,
      // PAN/TILT
      pan_angle: false,
      tilt_angle: false,
      pan_center: false,
      tilt_center: false,
      inv_pan: false,
      inv_tilt: false,
      time_pan: false,
      time_tilt: false,
    },
    types: lasers,
  },
  {
    label: 'profile.properties.other',
    value: fixtureFamilies.OTHER,
    icon: 'Images/Icons/profilebuilder/fixtures/Smoke.png',
    // What properties to show or not depending on type
    properties: {
      // LAMP
      lamp_power: false,
      lamp_ref: false,
      lamp_type: false,
      lamp_life: false,
      lamp_temp: false,
      color: false,
      // BEAM ANGLE
      beam_opening: false,
      beam_opening2: false,
      beam_type: false,
      // PAN/TILT
      pan_angle: false,
      tilt_angle: false,
      pan_center: false,
      tilt_center: false,
      inv_pan: false,
      inv_tilt: false,
      time_pan: false,
      time_tilt: false,
    },
    types: other,
  },
]

export const list = []

// For each family
for (let i = 0; i < families.length; i += 1) {
  const family = families[i]
  // For each fixture type in the family
  for (let j = 0; j < family.types.length; j += 1) {
    const type = family.types[j]
    // Hydrate the type with the reference to the family
    type.family = family
    // For each model in the fixture type
    for (let k = 0; k < type.models.length; k += 1) {
      const model = type.models[k]
      // Hydrate the model with the reference to the family
      model.family = family
      // Hydrate the model with the reference to the type
      model.type = type
      // Add the model to the list
      list.push(model)
    }
  }
}
